export const SET_PROPERTY_SINGLE_SUBDESTAJO = "SET_PROPERTY_SINGLE_SUBDESTAJO";
export const GET_ACTIVIDAD_PROGRAMADA = "GET_ACTIVIDAD_PROGRAMADA";
export const SET_PROPERTY_SUBDESTAJO = "SET_PROPERTY_SUBDESTAJO";
export const CREATE_NUEVO_SUBDESTAJO = "CREATE_NUEVO_SUBDESTAJO";
export const REORDENAR_SUBDESTAJOS = "REORDENAR_SUBDESTAJOS";
export const SUBDESTAJOS_RECEIVED = "SUBDESTAJOS_RECEIVED";
export const DELETE_SUBDESTAJO = "DELETE_SUBDESTAJO";
export const SET_SUBDESTAJO = "SET_SUBDESTAJO";
